import { Component, OnInit ,OnDestroy, Output, EventEmitter, ViewChild ,Input} from '@angular/core';


@Component({
  selector: 'lib-dashlib2',
  templateUrl: 'dashlib2.component.html',
  styleUrls: ['dashlib2.component.css']
})



export class Dashlib2Component implements OnInit {

  private COMPONENT_NAME: string = 'CustomerComponent';
  
  @Output() abc: any ='hello';
    clearAllStatus: boolean = false;
    stateItems: any[];
    @Input() customerModel: any = { address1: '', address2: '', city: '', dealerCode: '', email1: '', firstName: '', 
    lastName: '', middleName: '', phone1: '', state: null, validDealerCode: false, webOrderId: '', zipCode: '',
    eligibility:'',eligibilityDate:'',paymentCount:'',brandType:'',accountNumber:'',nonTMOMobileNumber:'',nonTMOMobilePin:'', 
    isValidated:false, eligibilityMsg:'',isorderlookup: false};

    disableFields: boolean = false;
    cartSummaryData: any = {};
    @ViewChild('conflictModel') conflictModel: any;
    @ViewChild('manualReviewModel') manualReviewModel: any;
    hasItemsInCart: boolean = false;
    creditType: string = 'CC'; // toggle between credit type[CC/NC]
    bdStoreId: number = 10553;
    rtStoreId: number = 10553;
    cdStoreId: number = 10553;
    csStoreId: number = 10553;
    creditClassS: string = 'A';
    
    subscription: any;
    storeId: number; // updating storeid
    //dealerCode : number;
    customer: any;
    
    KarmaTestResult: any = {};
    isEmailAvailable: boolean = false;
    showCreditDetail: boolean = true;
    hasPOAddress: boolean = false;
    
    suucessmsg: string;
    public customerModelpin: string;
    test : string;
    successmsg : string;
    public isValidated:boolean;
    eligibilityErrorMsg:string;
    eligibilityMsg:string;
    isAALOrder: boolean = false;
  constructor() { }

  ngOnInit() {
  }

}
